import { IconX } from '@tabler/icons-react';
import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import { postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { toast } from 'sonner';

const AddPromotionUrlModal = ({ buttonComponent, callback }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const add = async () => {

        let localData = {
            name: document.getElementById("name")?.value?.trim(),
            url: document.getElementById("url")?.value?.trim()
        }

        let postData = {
            promotionUrl: localData.url
        }

        if (localData?.name) {
            postData.name = localData.name
        }

        loadingShow();
        let resp = await postApi(postData, urlApi?.addPredefinedPromotionalUrl);
        loadingHide();
        if (resp.responseCode == 200) {
            toast.success(resp?.message);
            callback?.();
            handleClose();
        } else {
            toast.error(resp?.message);
        }

    }

    return (
        <>
            <div className='max-w-max' onClick={handleShow}>{buttonComponent}</div>
            <Modal show={show} onHide={handleClose} backdrop="static" size='lg'>
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold mb-0">Add an URL</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />
                    <div>
                        <div className='mb-3'>
                            <label htmlFor="name" className='text-sm font-semibold mb-1'>Name (Optional)</label>
                            <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='name' />
                        </div>
                        <div className='mb-3'>
                            <label htmlFor="url" className='text-sm font-semibold mb-1'>URL*</label>
                            <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='url' />
                        </div>
                    </div>

                    <hr className='my-3' />
                    <div className='flex justify-end gap-3'>
                        <button className='cancel-btn' onClick={handleClose}>Cancel</button>
                        <button className='primary-btn' onClick={() => add()}>Add</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default AddPromotionUrlModal